
import React from 'react'
import { Box } from '@mui/material'

const ExampleWrapperSeamless = (props) => {
  const { sectionHeading, children } = props

  return (
    <div data-hf="example-card-seamless">
      {sectionHeading && (
        <Box component="h5" sx={[{ mb: '1.5rem', fontWeight: 700 }, { fontSize: "1.7rem", fontWeight: "300", lineHeight: "1.2" }]}>
          {sectionHeading}
        </Box>
      )}
      {children}
    </div>
  )
}

export default ExampleWrapperSeamless
